//引入接口文档
import req from '@/utils/req.js'

// --------------

//渠道机构服务配置表添加,并获取ID
export function insertService(params) {
  return req.post("/admin/org-channel-service/saveBatch", params,{loading:true});
}

//渠道机构服务配置表更新
export function updateChannelService(params) {
  return req.put("/admin/org-channel-service", params);
}

//渠道机构服务配置表删除
export function delChannelService(id) {
  return req.delete(`/admin/org-channel-service/${id}`);
}

//渠道机构服务配置表详情
export function channelServiceDetail(id) {
  return req.get(`/admin/org-channel-service/${id}`);
}


//渠道机构表分页查询
export function searchChannel(params) {
  return req.post("/admin/org-channel/search", params);
}

//渠道机构表添加,并获取ID
export function addChannel(params) {
  return req.post("/admin/org-channel/insertReturnId", params,{loading:true});
}

//渠道机构表添加
export function addOrgChannel(params) {
  return req.post("/admin/org-channel", params);
}

//渠道机构表更新
export function updateOrgChannel(params) {
  return req.put("/admin/org-channel", params,{loading:true});
}

//渠道机构表详情
export function orgChannelDetail(id) {
  return req.get(`/admin/org-channel/${id}`);
}

//渠道类型下拉数据
export function getChannelType(params) {
  return req.get("/admin/category/channel_type/children",params);
}

//合作机构下拉数据
export function getCooperationType(params) {
  return req.get("/admin/category/cooperation_type/children",params);
}

//关联服务下拉数据
export function getCooperationService(params) {
  return req.get("/admin/category/cooperation_service/children",params);
}

//查询开户行
export function getBankBelong(bankCard) {
  return req.get(`/admin/bank/checkBankCard/${bankCard}`);
}

//分页获取机构名称 
export function getHospital(params) {
  return req.post("/admin/hospital/search",params);
}

//选择服务权益列表
export function getTeamServicePage(params) {
  return req.post("/admin/team-service/getTeamServicePage", params)
}

//渠道机构服务配置表列表查询
export function getChannelService(params) {
  return req.post("/admin/org-channel-service/list", params)
}
